import { Navigate, Outlet } from 'react-router-dom';
import Layout from './Layout';
import { isLogin } from '../utils/commonFunctions';


const PrivateRoutes = () => {
    const auth = isLogin();
    return (
        auth ? (
            <Layout>
                <Outlet />
            </Layout>
        ) : (
            <Navigate to='/login' />
        )
    );
};

export default PrivateRoutes;